import { t } from "@/i18n-js/instance";
import { Typography } from "@/react/components/shared/uikit/Typography";

const localeNamespace = "settings.workflows.templates.labels.new";

export function NewLabel() {
  return (
    <div className="flex h-[18px] items-center gap-1 rounded bg-red-500/10 px-1 py-px">
      <Typography.LabelXxs color="text-feedback-error">
        {t([localeNamespace, "label"])}
      </Typography.LabelXxs>
    </div>
  );
}
